import { render, staticRenderFns } from "./HistoryActiveClass.vue?vue&type=template&id=07fdbf6c&"
import script from "./HistoryActiveClass.vue?vue&type=script&lang=js&"
export * from "./HistoryActiveClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports